import './_commonjsHelpers-df867233.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './_isIterateeCall-c4941c92.js';
import { _ as _map } from './map-651e82c0.js';
import { _ as _join } from './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import { w as wrapMediaQuery } from './wrapMediaQuery-d94fbf55.js';
import Container from './Container.js';
import { _ as _range } from './range-409eafd0.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: -ms-grid;\n  display: grid;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getColumnTemplate = function getColumnTemplate(colCount) {
  return _map(_range(colCount), function () {
    return '1fr';
  }).join(' ');
};

var getColumnTemplateForIE = function getColumnTemplateForIE(colCount, gapSize) {
  return _map(_range(colCount), function () {
    return '1fr';
  }).join(" ".concat(gapSize, " "));
}; // Iterate over the responsive spaces to apply the corresponding rules


var responsiveGrid = function responsiveGrid(layout, spaces) {
  var gap = spaces[layout.gap] || layout.gap;
  return "\n    grid-gap: ".concat(gap, ";\n    -ms-grid-columns: ").concat(getColumnTemplateForIE(layout.cols, gap), ";\n    grid-template-columns: ").concat(getColumnTemplate(layout.cols), ";\n  ");
}; // By default, Container is full-sized and center-aligned


var Grid = styled(Container)(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return _join(_map(theme.layout, function (layout) {
    return wrapMediaQuery(layout.from, layout.to, responsiveGrid(layout, theme.spaces));
  }), '');
});

export default Grid;
